// import React, { useState, useEffect } from 'react'; // Added useEffect
// import { 
//   ChevronDown, ShieldCheck, BarChart3, Clock, Users, TrendingUp, 
//   Target, Zap, Heart, Award, CheckCircle, Send, MessageSquare, 
//   Phone, Mail, MapPin, CheckCircle2, Linkedin, Twitter, 
//   Facebook, Instagram, Loader2,
//   RefreshCcw // Added for captcha refresh
// } from 'lucide-react';
// import { motion, AnimatePresence } from 'framer-motion';
// // Import Toast components
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// import Image1 from "../../assets/employee.webp";
// import { API_URL } from '../../../Constants';

// // --- Contact Section Helper Components ---
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
// };

// const itemVariants = {
//   hidden: { opacity: 0, y: 15 },
//   visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
// };

// const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
//   <div className="flex flex-col space-y-1.5 text-left">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <input
//       type={type}
//       name={name}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       required={required}
//       readOnly={readOnly}
//       className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
//         readOnly 
//         ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed pointer-events-none select-none" 
//         : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
//       }`}
//     />
//   </div>
// );

// const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
//   <div className="flex flex-col space-y-1.5 text-left">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <textarea
//       name={name}
//       value={value}
//       onChange={onChange}
//       rows="4"
//       placeholder={placeholder}
//       required={required}
//       className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
//     />
//   </div>
// );

// const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
//   <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
//     <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//       <Icon className="text-white w-4 h-4" />
//     </div>
//     <div className="text-left">
//       <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
//       <p className="text-white text-base font-bold leading-tight">{content}</p>
//       {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
//     </div>
//   </motion.div>
// );

// const EmployeePage = () => {
//   // --- Form Logic Updated Keys ---
//   const [formState, setFormState] = useState({ 
//     fullName: '', 
//     email: '', 
//     phoneNumber: '', 
//     subject: 'Employee Tracking Demo Request', 
//     message: '' 
//   });
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // --- CAPTCHA LOGIC ---
//   const [captchaText, setCaptchaText] = useState('');
//   const [userInputCaptcha, setUserInputCaptcha] = useState('');

//   const generateCaptcha = () => {
//     const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//     let result = "";
//     for (let i = 0; i < 6; i++) {
//       result += chars.charAt(Math.floor(Math.random() * chars.length));
//     }
//     setCaptchaText(result);
//     setUserInputCaptcha('');
//   };

//   useEffect(() => {
//     generateCaptcha();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'phoneNumber') {
//         const cleaned = value.replace(/\D/g, ''); 
//         if (cleaned.length <= 10) {
//             setFormState({ ...formState, [name]: cleaned });
//         }
//         return;
//     }
//     setFormState({ ...formState, [name]: value });
//   };

//   const validateForm = () => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\d{10}$/;

//     if (!emailRegex.test(formState.email)) {
//       toast.error("Please enter a valid email address with '@'");
//       return false;
//     }
//     if (!phoneRegex.test(formState.phoneNumber)) {
//       toast.error("Phone number must be exactly 10 digits");
//       return false;
//     }
//     if (formState.fullName.trim().length < 2) {
//       toast.error("Please enter your full name");
//       return false;
//     }
//     if (userInputCaptcha.toUpperCase() !== captchaText) {
//       toast.error("Incorrect security code. Please try again.");
//       generateCaptcha();
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     setIsSubmitting(true);
//     try {
//       const response = await fetch(`${API_URL}/api/public/contact`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formState),
//       });

//       const result = await response.json();

//       if (response.ok && result.success) {
//         setIsSubmitted(true);
//         toast.success(result.message || "Request sent successfully!");
//         setFormState({ 
//           fullName: '', email: '', phoneNumber: '', 
//           subject: 'Employee Tracking Demo Request', message: '' 
//         });
//         generateCaptcha();
//       } else {
//         toast.error(result.message || "Something went wrong. Please try again.");
//         generateCaptcha();
//       }
//     } catch (error) { 
//       console.error("API Error:", error); 
//       toast.error("Failed to connect to the server.");
//     } finally { 
//       setIsSubmitting(false); 
//     }
//   };

//   const bgPuzzleStyle = {
//     backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
//     backgroundSize: '30px 30px',
//   };

//   return (
//     <main className="min-h-screen font-sans">
//       <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
//       {/* SECTION 1: HERO */}
//       <section className="bg-[#EEF2FC] py-16 px-6 lg:px-20 overflow-hidden">
//         <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12">
//           <div className="flex-1 text-center lg:text-left lg:pl-0 lg:pr-12 lg:-mt-4">
//             <h1 className="text-4xl lg:text-5xl font-medium text-slate-900 leading-[1.1] tracking-tight mb-6">
//               Employee Tracking <br className="hidden lg:block" /> System
//             </h1>
//             <p className="text-lg text-slate-700 mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0">
//               Efficiently track employee performance, streamline attendance, and manage tasks with a powerful Employee Tracking System. Enhance productivity, optimize workforce management, and ensure seamless operations for business growth.
//             </p>
//             <a 
//               href="#contact-start" 
//               className="inline-flex items-center gap-2 px-6 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md "
//             >
//               Request a Demo
//               <ChevronDown className="w-5 h-5 animate-bounce" />
//             </a>
//           </div>

//           <div className="flex-1 w-full flex justify-center lg:justify-start lg:-mt-20 lg:-ml-16"> 
//             <div className="relative w-full max-w-lg">
//               <img 
//                 src={Image1} 
//                 alt="Employee Tracking Dashboard" 
//                 className="w-full h-auto max-h-[450px] object-contain drop-shadow-2xl"
//               />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* SECTION 2: FEATURES */}
//       <section className="bg-[#EEF2FC] py-24 px-6 lg:px-20 -mt-16">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center max-w-3xl mx-auto mb-16">
//             <h2 className="text-3xl lg:text-4xl font-semibold text-slate-900 mb-4 tracking-tight">
//               Powerful Features for Modern Teams
//             </h2>
//             <p className="text-slate-600 text-lg">
//               Everything you need to manage your workforce effectively in one unified platform.
//             </p>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
//             {features.map((feature, index) => (
//               <div key={index} className="group p-8 bg-[#D0DCF2] rounded-3xl border border-transparent hover:border-blue-200 hover:shadow-xl transition-all duration-300 text-left">
//                 <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center shadow-sm mb-6 group-hover:bg-slate-900 group-hover:text-white transition-colors duration-300">
//                   {feature.icon}
//                 </div>
//                 <h3 className="text-xl font-medium text-slate-900 mb-3">{feature.title}</h3>
//                 <p className="text-slate-700 leading-relaxed text-sm lg:text-base">{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* SECTION 3: BENEFITS & RESULTS */}
//       <section className="py-24 px-6 lg:px-20 bg-[#EEF2FC] -mt-16">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center max-w-3xl mx-auto mb-16">
//             <h2 className="text-3xl lg:text-4xl font-semibold text-slate-900 mb-4 tracking-tight">
//               Measurable Results & Business Impact
//             </h2>
//             <p className="text-slate-600 text-lg">See how leading companies transform their workforce management and achieve tangible results</p>
//           </div>
//           <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
//             <div className="flex-1">
//               <h3 className="text-2xl font-semibold text-slate-900 mb-6 flex items-center gap-3 text-left">
//                 <Target className="w-7 h-7 text-blue-600" />
//                 Key Benefits You'll Experience
//               </h3>
//               <div className="space-y-6">
//                 {benefits.map((benefit, index) => (
//                   <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-slate-50 transition-colors text-left">
//                     <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
//                       {benefit.icon}
//                     </div>
//                     <div>
//                       <h4 className="text-lg font-medium text-slate-900 mb-1">{benefit.title}</h4>
//                       <p className="text-slate-600 text-sm">{benefit.description}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="flex-1">
//               <div className="bg-slate-900 rounded-2xl p-8 lg:p-10 text-white text-left">
//                 <h3 className="text-2xl font-semibold mb-8 flex items-center gap-3">
//                   <TrendingUp className="w-7 h-7" />
//                   Average Results Achieved
//                 </h3>
//                 <div className="space-y-8">
//                   {results.map((result, index) => (
//                     <div key={index} className="relative">
//                       <div className="flex justify-between items-center mb-2">
//                         <span className="text-lg font-medium">{result.title}</span>
//                         <span className="text-2xl font-bold text-green-400">{result.percentage}</span>
//                       </div>
//                       <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
//                         <div className="h-full bg-gradient-to-r from-green-400 to-blue-400" style={{ width: result.percentage }}></div>
//                       </div>
//                       <p className="text-slate-300 text-sm mt-2">{result.description}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* SECTION 4: CONTACT & REQUEST DEMO */}
//       <section id="contact-start" className="py-16 relative overflow-hidden">
//         <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
//         <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
//         <div className="container mx-auto px-4 relative z-10">
//           <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
            
//             {/* LEFT SIDE: INFO */}
//             <motion.div variants={itemVariants} className="space-y-8">
//               <div>
//                 <div className="inline-flex items-center gap-2 mb-2">
//                   <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
//                   <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">GET IN TOUCH</span>
//                 </div>
//                 <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">Request an <span className="text-[#F46653]">ETS Demo</span></h2>
//                 <p className="text-white/70 text-base leading-relaxed text-left">Our dedicated support team is available 24/7 to assist with your workforce management and communication needs.</p>
//               </div>

//               <div className="space-y-3">
//                 <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
//                 <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
//                 <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
//                 <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
//               </div>

//               <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
//                 <p className="text-white text-base font-bold mb-2 text-left">Connect With Us -</p>
//                 <div className="flex gap-3">
//                   {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
//                     <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-all group">
//                       <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
//                     </motion.a>
//                   ))}
//                 </div>
//               </motion.div>
//             </motion.div>

//             {/* RIGHT SIDE: FORM */}
//             <motion.div variants={itemVariants}>
//               <div className="bg-white rounded-3xl shadow-2xl p-8">
//                 <AnimatePresence mode="wait">
//                   {isSubmitted ? (
//                     <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
//                       <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                       <h3 className="text-3xl font-bold text-gray-800 mb-4 text-center">Request Sent!</h3>
//                       <p className="text-gray-600 mb-8 text-center">Our team will get back to you within 2 hours to schedule your Employee Tracking demo.</p>
//                       <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl">Back to Form</button>
//                     </motion.div>
//                   ) : (
//                     <motion.div key="form">
//                       <div className="flex items-center gap-3 mb-6">
//                         <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
//                         <div><p className="text-2xl font-bold text-gray-800 text-left">Send Us a Message</p></div>
//                       </div>
//                       <form onSubmit={handleSubmit} className="space-y-5">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
//                           <InputField label=" Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
//                         </div>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
//                           <InputField label="Subject" name="subject" value={formState.subject} readOnly={true} />
//                         </div>
//                         <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

//                         {/* --- ADDED CAPTCHA FIELD --- */}
//                         <div className="flex flex-col space-y-1.5 pt-2 text-left">
//                           <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
//                           <div className="flex items-center gap-4">
//                             <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
//                               <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
//                                 {captchaText}
//                               </span>
//                             </div>
//                             <button 
//                               type="button" 
//                               onClick={generateCaptcha} 
//                               className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                               title="Refresh Code"
//                             >
//                               <RefreshCcw className="w-5 h-5 text-gray-500" />
//                             </button>
//                             <div className="flex-1">
//                               <input
//                                 type="text"
//                                 placeholder="Enter code"
//                                 value={userInputCaptcha}
//                                 onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
//                                 className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>

//                         <motion.button 
//                           disabled={isSubmitting || userInputCaptcha.length < 6} 
//                           whileHover={{ scale: isSubmitting ? 1 : 1.02 }} 
//                           whileTap={{ scale: isSubmitting ? 1 : 0.98 }} 
//                           type="submit" 
//                           className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//                         >
//                           {isSubmitting ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Send Message <Send className="w-5 h-5" /></>}
//                         </motion.button>
//                       </form>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>
//     </main>
//   );
// };

// // --- Data Arrays ---
// const features = [
//   { title: "Real-time Tracking", description: "Monitor daily check-ins, active hours, and real-time location with precision and ease.", icon: <Clock className="w-6 h-6" /> },
//   { title: "Insightful Analytics", description: "Turn raw data into actionable insights with automated performance reports and charts.", icon: <BarChart3 className="w-6 h-6" /> },
//   { title: "Secure & Private", description: "Enterprise-grade security ensures that your employee data remains confidential and safe.", icon: <ShieldCheck className="w-6 h-6" /> },
//   { title: "Seamless Sync", description: "Connect your existing HR tools and payroll systems effortlessly with our open API.", icon: <Users className="w-6 h-6" /> },
// ];

// const benefits = [
//   { title: "Boost Productivity", description: "Teams using our system report an average 42% increase in productivity and better time management.", icon: <Zap className="w-5 h-5 text-blue-600" /> },
//   { title: "Reduce Administrative Costs", description: "Automate manual processes and reduce HR administrative time by up to 65%.", icon: <TrendingUp className="w-5 h-5 text-blue-600" /> },
//   { title: "Improve Employee Satisfaction", description: "Transparent tracking and fair workload distribution lead to higher employee engagement.", icon: <Heart className="w-5 h-5 text-blue-600" /> },
//   { title: "Accurate Project Billing", description: "Precisely track billable hours and project time allocation for accurate client invoicing.", icon: <CheckCircle className="w-5 h-5 text-blue-600" /> },
// ];

// const results = [
//   { title: "Productivity Improvement", percentage: "42%", description: "Average increase in team productivity across all departments" },
//   { title: "Time Saved on Admin Tasks", percentage: "65%", description: "Reduction in manual HR and administrative work" },
//   { title: "Project Delivery Accuracy", percentage: "78%", description: "Improvement in on-time project completion rates" },
//   { title: "Employee Retention", percentage: "31%", description: "Higher retention rates due to improved work-life balance tracking" },
// ];

// export default EmployeePage;




import React, { useState, useEffect } from 'react'; // Added useEffect
import { Link } from 'react-router-dom'; // Added Link import for routing
import { 
  ChevronDown, ShieldCheck, BarChart3, Clock, Users, TrendingUp, 
  Target, Zap, Heart, Award, CheckCircle, Send, MessageSquare, 
  Phone, Mail, MapPin, CheckCircle2, Linkedin, Twitter, 
  Facebook, Instagram, Loader2,
  RefreshCcw // Added for captcha refresh
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// Import Toast components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Image1 from "../../assets/employee.webp";
import { API_URL } from '../../../Constants';

// --- Contact Section Helper Components ---
const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
};

const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
  <div className="flex flex-col space-y-1.5 text-left">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      readOnly={readOnly}
      className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
        readOnly 
        ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed pointer-events-none select-none" 
        : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
      }`}
    />
  </div>
);

const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
  <div className="flex flex-col space-y-1.5 text-left">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      rows="4"
      placeholder={placeholder}
      required={required}
      className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
    />
  </div>
);

const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
  <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
    <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
      <Icon className="text-white w-4 h-4" />
    </div>
    <div className="text-left">
      <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
      <p className="text-white text-base font-bold leading-tight">{content}</p>
      {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
    </div>
  </motion.div>
);

const EmployeePage = () => {
  // --- Form Logic Updated Keys ---
  const [formState, setFormState] = useState({ 
    fullName: '', 
    email: '', 
    phoneNumber: '', 
    subject: 'Employee Tracking Demo Request', 
    message: '' 
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false); // Added consent state

  // --- CAPTCHA LOGIC ---
  const [captchaText, setCaptchaText] = useState('');
  const [userInputCaptcha, setUserInputCaptcha] = useState('');

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInputCaptcha('');
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phoneNumber') {
        const cleaned = value.replace(/\D/g, ''); 
        if (cleaned.length <= 10) {
            setFormState({ ...formState, [name]: cleaned });
        }
        return;
    }
    setFormState({ ...formState, [name]: value });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(formState.email)) {
      toast.error("Please enter a valid email address with '@'");
      return false;
    }
    if (!phoneRegex.test(formState.phoneNumber)) {
      toast.error("Phone number must be exactly 10 digits");
      return false;
    }
    if (formState.fullName.trim().length < 2) {
      toast.error("Please enter your full name");
      return false;
    }
    if (!consentGiven) { // Final check for Consent
      toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
      return false;
    }
    if (userInputCaptcha.toUpperCase() !== captchaText) {
      toast.error("Incorrect security code. Please try again.");
      generateCaptcha();
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/api/public/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setIsSubmitted(true);
        toast.success(result.message || "Request sent successfully!");
        setFormState({ 
          fullName: '', email: '', phoneNumber: '', 
          subject: 'Employee Tracking Demo Request', message: '' 
        });
        setConsentGiven(false); // Reset consent after success
        generateCaptcha();
      } else {
        toast.error(result.message || "Something went wrong. Please try again.");
        generateCaptcha();
      }
    } catch (error) { 
      console.error("API Error:", error); 
      toast.error("Failed to connect to the server.");
    } finally { 
      setIsSubmitting(false); 
    }
  };

  const bgPuzzleStyle = {
    backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
    backgroundSize: '30px 30px',
  };

  return (
    <main className="min-h-screen font-sans">
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
      {/* SECTION 1: HERO */}
      <section className="bg-[#EEF2FC] py-16 px-6 lg:px-20 overflow-hidden">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 text-center lg:text-left lg:pl-0 lg:pr-12 lg:-mt-4">
            <h1 className="text-4xl lg:text-5xl font-medium text-slate-900 leading-[1.1] tracking-tight mb-6">
              Employee Tracking <br className="hidden lg:block" /> System
            </h1>
            <p className="text-lg text-slate-700 mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0">
              Efficiently track employee performance, streamline attendance, and manage tasks with a powerful Employee Tracking System. Enhance productivity, optimize workforce management, and ensure seamless operations for business growth.
            </p>
            <a 
              href="#contact-start" 
              className="inline-flex items-center gap-2 px-6 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md "
            >
              Request a Demo
              <ChevronDown className="w-5 h-5 animate-bounce" />
            </a>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-start lg:-mt-20 lg:-ml-16"> 
            <div className="relative w-full max-w-lg">
              <img 
                src={Image1} 
                alt="Employee Tracking Dashboard" 
                className="w-full h-auto max-h-[450px] object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: FEATURES */}
      <section className="bg-[#EEF2FC] py-24 px-6 lg:px-20 -mt-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl lg:text-4xl font-semibold text-slate-900 mb-4 tracking-tight">
              Powerful Features for Modern Teams
            </h2>
            <p className="text-slate-600 text-lg">
              Everything you need to manage your workforce effectively in one unified platform.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="group p-8 bg-[#D0DCF2] rounded-3xl border border-transparent hover:border-blue-200 hover:shadow-xl transition-all duration-300 text-left">
                <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center shadow-sm mb-6 group-hover:bg-slate-900 group-hover:text-white transition-colors duration-300">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-medium text-slate-900 mb-3">{feature.title}</h3>
                <p className="text-slate-700 leading-relaxed text-sm lg:text-base">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 3: BENEFITS & RESULTS */}
      <section className="py-24 px-6 lg:px-20 bg-[#EEF2FC] -mt-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl lg:text-4xl font-semibold text-slate-900 mb-4 tracking-tight">
              Measurable Results & Business Impact
            </h2>
            <p className="text-slate-600 text-lg">See how leading companies transform their workforce management and achieve tangible results</p>
          </div>
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
            <div className="flex-1">
              <h3 className="text-2xl font-semibold text-slate-900 mb-6 flex items-center gap-3 text-left">
                <Target className="w-7 h-7 text-blue-600" />
                Key Benefits You'll Experience
              </h3>
              <div className="space-y-6">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-slate-50 transition-colors text-left">
                    <div className="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
                      {benefit.icon}
                    </div>
                    <div>
                      <h4 className="text-lg font-medium text-slate-900 mb-1">{benefit.title}</h4>
                      <p className="text-slate-600 text-sm">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex-1">
              <div className="bg-slate-900 rounded-2xl p-8 lg:p-10 text-white text-left">
                <h3 className="text-2xl font-semibold mb-8 flex items-center gap-3">
                  <TrendingUp className="w-7 h-7" />
                  Average Results Achieved
                </h3>
                <div className="space-y-8">
                  {results.map((result, index) => (
                    <div key={index} className="relative">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-lg font-medium">{result.title}</span>
                        <span className="text-2xl font-bold text-green-400">{result.percentage}</span>
                      </div>
                      <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
                        <div className="h-full bg-gradient-to-r from-green-400 to-blue-400" style={{ width: result.percentage }}></div>
                      </div>
                      <p className="text-slate-300 text-sm mt-2">{result.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: CONTACT & REQUEST DEMO */}
      <section id="contact-start" className="py-16 relative overflow-hidden">
        <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
            
            {/* LEFT SIDE: INFO */}
            <motion.div variants={itemVariants} className="space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 mb-2">
                  <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
                  <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">GET IN TOUCH</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">Request an <span className="text-[#F46653]">ETS Demo</span></h2>
                <p className="text-white/70 text-base leading-relaxed text-left">Our dedicated support team is available 24/7 to assist with your workforce management and communication needs.</p>
              </div>

              <div className="space-y-3">
                <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
                <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
                <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
                <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
              </div>

              <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
                <p className="text-white text-base font-bold mb-2 text-left">Connect With Us -</p>
                <div className="flex gap-3">
                  {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
                    <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-all group">
                      <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            </motion.div>

            {/* RIGHT SIDE: FORM */}
            <motion.div variants={itemVariants}>
              <div className="bg-white rounded-3xl shadow-2xl p-8">
                <AnimatePresence mode="wait">
                  {isSubmitted ? (
                    <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
                      <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
                      <h3 className="text-3xl font-bold text-gray-800 mb-4 text-center">Request Sent!</h3>
                      <p className="text-gray-600 mb-8 text-center">Our team will get back to you within 2 hours to schedule your Employee Tracking demo.</p>
                      <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl">Back to Form</button>
                    </motion.div>
                  ) : (
                    <motion.div key="form">
                      <div className="flex items-center gap-3 mb-6">
                        <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
                        <div><p className="text-2xl font-bold text-gray-800 text-left">Send Us a Message</p></div>
                      </div>
                      <form onSubmit={handleSubmit} className="space-y-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
                          <InputField label=" Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
                          <InputField label="Subject" name="subject" value={formState.subject} readOnly={true} />
                        </div>
                        <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

                        {/* --- ADDED CAPTCHA FIELD --- */}
                        <div className="flex flex-col space-y-1.5 pt-2 text-left">
                          <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
                          <div className="flex items-center gap-4">
                            <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
                              <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
                                {captchaText}
                              </span>
                            </div>
                            <button 
                              type="button" 
                              onClick={generateCaptcha} 
                              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                              title="Refresh Code"
                            >
                              <RefreshCcw className="w-5 h-5 text-gray-500" />
                            </button>
                            <div className="flex-1">
                              <input
                                type="text"
                                placeholder="Enter code"
                                value={userInputCaptcha}
                                onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
                                className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        {/* --- CONSENT CHECKBOX --- */}
                        <div className="flex items-start gap-3 pt-2 text-left">
                          <input
                            type="checkbox"
                            id="consent"
                            checked={consentGiven}
                            onChange={(e) => setConsentGiven(e.target.checked)}
                            className="mt-1 min-w-[1rem] w-4 h-4 text-[#0C4550] border-gray-300 rounded focus:ring-[#0C4550] cursor-pointer"
                            required
                          />
                          <label htmlFor="consent" className="text-sm text-gray-600 leading-relaxed cursor-pointer select-none">
                            I agree to the <Link to="/terms-and-conditions" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Terms & Conditions</Link> and <Link to="/privacy-policy" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Privacy Policy</Link> and consent to receive communications from <strong>Deetya Soft Private Limited</strong> via SMS, Email, Calls, RCS Messages, and WhatsApp.
                          </label>
                        </div>

                        <motion.button 
                          disabled={isSubmitting || userInputCaptcha.length < 6 || !consentGiven} 
                          whileHover={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 1.02 }} 
                          whileTap={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 0.98 }} 
                          type="submit" 
                          className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {isSubmitting ? <Loader2 className="w-5 h-5 animate-spin" /> : <>Send Message <Send className="w-5 h-5" /></>}
                        </motion.button>
                      </form>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

// --- Data Arrays ---
const features = [
  { title: "Real-time Tracking", description: "Monitor daily check-ins, active hours, and real-time location with precision and ease.", icon: <Clock className="w-6 h-6" /> },
  { title: "Insightful Analytics", description: "Turn raw data into actionable insights with automated performance reports and charts.", icon: <BarChart3 className="w-6 h-6" /> },
  { title: "Secure & Private", description: "Enterprise-grade security ensures that your employee data remains confidential and safe.", icon: <ShieldCheck className="w-6 h-6" /> },
  { title: "Seamless Sync", description: "Connect your existing HR tools and payroll systems effortlessly with our open API.", icon: <Users className="w-6 h-6" /> },
];

const benefits = [
  { title: "Boost Productivity", description: "Teams using our system report an average 42% increase in productivity and better time management.", icon: <Zap className="w-5 h-5 text-blue-600" /> },
  { title: "Reduce Administrative Costs", description: "Automate manual processes and reduce HR administrative time by up to 65%.", icon: <TrendingUp className="w-5 h-5 text-blue-600" /> },
  { title: "Improve Employee Satisfaction", description: "Transparent tracking and fair workload distribution lead to higher employee engagement.", icon: <Heart className="w-5 h-5 text-blue-600" /> },
  { title: "Accurate Project Billing", description: "Precisely track billable hours and project time allocation for accurate client invoicing.", icon: <CheckCircle className="w-5 h-5 text-blue-600" /> },
];

const results = [
  { title: "Productivity Improvement", percentage: "42%", description: "Average increase in team productivity across all departments" },
  { title: "Time Saved on Admin Tasks", percentage: "65%", description: "Reduction in manual HR and administrative work" },
  { title: "Project Delivery Accuracy", percentage: "78%", description: "Improvement in on-time project completion rates" },
  { title: "Employee Retention", percentage: "31%", description: "Higher retention rates due to improved work-life balance tracking" },
];

export default EmployeePage;